<template>
  <v-row v-loading="!dataLoaded">

    <v-col cols="12" class="pt-0">
      <PageTitle title="Управление сроками" />
    </v-col>

    <v-col cols="12" class="pt-0">
      <v-btn
        small
        outlined
        rounded
        color="primary"
        class="white--text px-4"
        @click="dialog = true"
      >
        <v-icon left small>mdi-plus</v-icon>Добавить
      </v-btn>
    </v-col>

    <v-col cols="12" class="py-0">
      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        :table-items="localBlockTriggerParent.list"
        filter
      >
<!--        <template v-slot:button>-->
<!--          <v-badge-->
<!--            overlap-->
<!--            dot-->
<!--            :value="!!checkProperty"-->
<!--          >-->
<!--            <v-btn-->
<!--              v-if="checkRoles"-->
<!--              small-->
<!--              outlined-->
<!--              rounded-->
<!--              color="primary"-->
<!--              class="white&#45;&#45;text ml-4 filter-btn"-->
<!--              @click="showFilter = !showFilter"-->
<!--            >-->
<!--              <v-icon left small>mdi-filter-outline</v-icon>-->
<!--              <span class="">{{ showFilter ? 'Закрыть' : 'Фильтр' }}</span>-->
<!--            </v-btn>-->
<!--          </v-badge>-->
<!--        </template>-->

        <template v-slot:item.submissionSession="{ item }">
          {{ `${item.submissionSession?.semester?.name} ${item.submissionSession?.year?.name}`}}
        </template>

        <template v-slot:item.startDate="{ item }">
          {{ startDateFunc(item) }}
        </template>

        <template v-slot:item.startTime="{ item }">
          {{ startTimeFunc(item) }}
        </template>

        <template v-slot:item.endDate="{ item }">
          {{ endDateFunc(item) }}
        </template>

        <template v-slot:item.endTime="{ item }">
          {{ endTimeFunc(item) }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
            mdi-pencil-outline
          </v-icon>
          <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </PageTable>
    </v-col>

    <DeadlinePageDialog
      :dialog="dialog"
      :loading="btnLoading"
      :selectedItem="selectedItem"
      @saveBlockTrigger="saveDeadline"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeDeadline"
      @closeModal="closeDialog"
    />

<!--    <transition name="deadline-filter">-->
<!--      <DeadlineFilterComponent-->
<!--        v-show="showFilter"-->
<!--        @applyFilter="applyFilter"-->
<!--        @closeFilter="showFilter = false"-->
<!--        width-filter="250"-->
<!--        top="255"-->
<!--        right="29"-->
<!--      />-->
<!--    </transition>-->

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '@/components/ui/Title'
import PageTable from '@/components/ui/Table'
import {BlockTriggerParent} from '@/models'
import { blockTriggerApi } from '@/api'
import DeadlinePageDialog from '@/components/zvp/deadlinePage/DeadlinePage'
import DeadlineFilterComponent from '@/components/zvp/deadlinePage/DeadlineFilter'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'
import { getIsoDate, getFormatDate } from '@/scripts'

export default {
  name: "Deadlines",

  components: {
    PageTitle,
    PageTable,
    ConfirmDialog,
    DeadlinePageDialog,
    DeadlineFilterComponent
  },

  async created() {
    if (!this.checkRoles) {
      await this.$router.push('/')
    } else {
      await this.getDeadlines()
      this.dataLoaded = true
    }
  },

  data() {
    return {
      tableHeaders: [
        { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start' },
        { text: 'Семестр', value: 'submissionSession', sortable: false, align: 'start' },
        { text: 'Дата начала', value: 'startDate', sortable: false, align: 'start', width: '150px' },
        { text: 'Время начала', value: 'startTime', sortable: false, align: 'start', width: '150px' },
        { text: 'Дата окончания', value: 'endDate', sortable: false, align: 'start', width: '150px' },
        { text: 'Время окончания', value: 'endTime', sortable: false, align: 'start', width: '150px' },
        { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' }
      ],
      localBlockTriggerParent: new BlockTriggerParent(),
      // deadlineFilter: new DeadlineFilter(),
      showFilter: false,
      tableLoading: false,
      selectedItem: null,
      confirmDialog: false,

      btnLoading: false,
      dataLoaded: false,
      dialog: false
    }
  },

  computed: {
    ...mapGetters('user', ['isCurator', 'isAdmin']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },

    // checkProperty() {
    //   return this.deadlineFilter.courseNumber || this.deadlineFilter.speciality
    // },
  },

  methods: {
    // async applyFilter(item) {
    //   this.deadlineFilter = item ? item : new DeadlineFilter()
    //   this.blockTriggers.list = []
    //   await this.getDeadlines()
    // },

    async getDeadlines() {
      this.tableLoading = true
      try {
        const data = await blockTriggerApi.getCatalog()
        data.length && this.localBlockTriggerParent.build(data)
      } catch(e) {
        this.showErrorMessage(e)
      }
      finally {
        this.tableLoading = false
      }
    },

    startDateFunc(item) {
      return getFormatDate(item.startDateTime?.slice(0, -6))
    },

    startTimeFunc(item) {
      return item.startDateTime?.slice(-5)
    },

    endDateFunc(item) {
      return getFormatDate(item.endDateTime?.slice(0, -6))
    },

    endTimeFunc(item) {
      return item.endDateTime?.slice(-5)
    },

    async saveDeadline(item) {
      try {
        this.btnLoading = true
        const data = item.id ? await blockTriggerApi.update(item) : await blockTriggerApi.create(item)
        item.id ? this.localBlockTriggerParent.update(data) : this.localBlockTriggerParent.add(data)
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.btnLoading = false
      }
    },

    async removeDeadline() {
      try {
        this.btnLoading = true
        await blockTriggerApi.remove(this.selectedItem.id)
        this.localBlockTriggerParent.remove(this.selectedItem)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.btnLoading = false
      }
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  }
}
</script>

<style scoped>
.deadline-filter-enter-active {
  transition: opacity .2s;
}

.deadline-filter-leave-active {
  transition: opacity .2s;
}

.deadline-filter-enter, .deadline-filter-leave-to {
  opacity: 0;
}

.filter-btn {
  width: 150px;
}

.filter-btn span {
  width: 70px;
}
</style>
